export const LIST_EVENTS = `homepage/list-event`;
